module.exports = __webpack_public_path__ + "img/metas1-700x840.4c14512b.jpg";